import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import { oops as e2eClasses } from 'constants/e2eClasses'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  margin-top: 40px;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;

  ${mediaQueries.mobile`
    width: 100%;
    padding: 20px;
  `};
`

export const Image = styled.img.attrs(() => ({
  className: e2eClasses.img
}))`
  width: 650px;

  ${mediaQueries.mobile`
    width: 300px;
  `};
`

export const Title = styled.div.attrs(() => ({
  className: e2eClasses.title
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.blue};
  font-size: 80px;

  ${mediaQueries.mobile`
    font-size: 70px;
  `};
`

export const ButtonWrapper = styled.div`
  margin-top: 10px;
  ${({ fullWidth }) => !fullWidth && 'display: grid;'}
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
  width: 100%;

  ${mediaQueries.mobile`
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: auto;
    grid-gap: 30px;
    margin-top: 30px;
  `};
`

export const SecondaryTitle = styled.h4.attrs(props => ({
  className: props.e2eClass
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.doveGray};

  font-size: 20px;

  ${mediaQueries.mobile`
    font-size: 16px;
  `};
`

export const ErrorMessage = styled(SecondaryTitle)`
  font-size: 16px;

  ${mediaQueries.mobile`
    font-size: 14px;
  `};
`
